import { larryMediaArray } from './larryMedia'
import { larryBio } from './larryBios'

import { leonReviewerReviewHinge, leonReviewerReviewBumble, leonReviewerReviewTinder } from './larryReviewerReviews'
import { leonReviewerProfile } from './larryReviewers'

export const leonProfileReviewHinge = {
  _id: 'leonProfileReviewHingeId',
  userId: 'larryUserId',
  userEmail: 'larry@email.com',
  datingProfileId: 'larryDatingProfileHingeId',
  reviewerProfileId: 'leonReviewerProfileId',
  reviewerEmail: 'leon@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: larryMediaArray[12]._id,
      mediaItemURL: larryMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[12].type,
      caption: larryMediaArray[12].captions[0],
      subcaption: larryMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[1]._id,
      mediaItemURL: larryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[1].type,
      caption: larryMediaArray[1].captions[0],
      subcaption: larryMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[8]._id,
      mediaItemURL: larryMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[8].type,
      caption: larryMediaArray[8].captions[0],
      subcaption: larryMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[20]._id,
      mediaItemURL: larryMediaArray[20].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[20].type,
      caption: larryMediaArray[20].captions[0],
      subcaption: larryMediaArray[20].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[10]._id,
      mediaItemURL: larryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[10].type,
      caption: larryMediaArray[10].captions[0],
      subcaption: larryMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[13]._id,
      mediaItemURL: larryMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[13].type,
      caption: larryMediaArray[13].captions[0],
      subcaption: larryMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow! What a romantic! I didn't know you had this in you Larry`,
      verdict: 'Very',
    },
    {
      feedback: `The jacket, the desk, and the relaxed leg are all good. I like the photo`,
      verdict: 'Yes',
    },
    {
      feedback: `Kind of funny, but this perpetually aggrieved look makes you seem a bit difficult`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Fun change of pace. Maybe explain it in the captions`,
      verdict: 'Yes',
    },
    {
      feedback: `Social proof, gotta have it`,
      verdict: 'Yes',
    },
    {
      feedback: `Three perpetually aggrieved expressions out of six photos might be a bit much. Like the setting though`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: larryBio._id,
    vitalInfo: { ...larryBio.vitalInfo },
    prompts: [
      { ...larryBio.prompts[0] },
      { ...larryBio.prompts[1] },
      { ...larryBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Comedian barely explains it. You gotta mention that you created Seinfeld!`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get the reference here`,
        verdict: 'No', 
      },
      {
        feedback: `I like this, it shows you as detail oriented`,
        verdict: 'Yes', 
      },
      {
        feedback: `Maybe a bit too intense, but it does allow you to tell your story about donating a kidney for your friend`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Larry is well put together and has a good sense of humor but might be a bit difficult in a perpetually aggrieved sort of way`,
    good: `You seem funny and well put together with a lot of character`,
    notGood: `Some of the prompts don't land, you should flaunt Seinfeld, and you should switch out one or two of the perpetually aggrieved photos`,
    verdict: `Honestly it's a pretty good profile. No dealbreakers. Just switch out one or two of the perpetually aggrieved photos and update the prompts that aren't landing`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...leonReviewerReviewHinge },
  reviewerProfile: { ...leonReviewerProfile },
  bioItems: { ...larryBio },
  mediaItems: [ ...larryMediaArray ],
}

export const leonProfileReviewBumble = {
  _id: 'leonProfileReviewBumbleId',
  userId: 'larryUserId',
  userEmail: 'larry@email.com',
  datingProfileId: 'larryDatingProfileBumbleId',
  reviewerProfileId: 'leonReviewerProfileId',
  reviewerEmail: 'leon@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: larryMediaArray[12]._id,
      mediaItemURL: larryMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[12].type,
      caption: larryMediaArray[12].captions[0],
      subcaption: larryMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[1]._id,
      mediaItemURL: larryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[1].type,
      caption: larryMediaArray[1].captions[0],
      subcaption: larryMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[8]._id,
      mediaItemURL: larryMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[8].type,
      caption: larryMediaArray[8].captions[0],
      subcaption: larryMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[20]._id,
      mediaItemURL: larryMediaArray[20].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[20].type,
      caption: larryMediaArray[20].captions[0],
      subcaption: larryMediaArray[20].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[10]._id,
      mediaItemURL: larryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[10].type,
      caption: larryMediaArray[10].captions[0],
      subcaption: larryMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[13]._id,
      mediaItemURL: larryMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[13].type,
      caption: larryMediaArray[13].captions[0],
      subcaption: larryMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow! What a romantic! I didn't know you had this in you Larry`,
      verdict: 'Very',
    },
    {
      feedback: `The jacket, the desk, and the relaxed leg are all good. I like the photo`,
      verdict: 'Yes',
    },
    {
      feedback: `Kind of funny, but this perpetually aggrieved look makes you seem a bit difficult`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Fun change of pace. Maybe explain it in the captions`,
      verdict: 'Yes',
    },
    {
      feedback: `Social proof, gotta have it`,
      verdict: 'Yes',
    },
    {
      feedback: `Three perpetually aggrieved expressions out of six photos might be a bit much. Like the setting though`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: larryBio._id,
    vitalInfo: { ...larryBio.vitalInfo },
    prompts: [
      { ...larryBio.prompts[0] },
      { ...larryBio.prompts[1] },
      { ...larryBio.prompts[2] }
    ],
    aboutMe: larryBio.aboutMe[0],
    hobbies: [larryBio.hobbies[0], larryBio.hobbies[1], larryBio.hobbies[2], larryBio.hobbies[3], larryBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Comedian barely explains it. You gotta mention that you created Seinfeld!`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: 'Yes, this is funny',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get the reference here`,
        verdict: 'No', 
      },
      {
        feedback: `I like this, it shows you as detail oriented`,
        verdict: 'Yes', 
      },
      {
        feedback: `Maybe a bit too intense, but it does allow you to tell your story about donating a kidney for your friend`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Larry is well put together and has a good sense of humor but might be a bit difficult in a perpetually aggrieved sort of way`,
    good: `You seem funny and well put together with a lot of character`,
    notGood: `Some of the prompts don't land, you should flaunt Seinfeld, and you should switch out one or two of the perpetually aggrieved photos`,
    verdict: `Honestly it's a pretty good profile. No dealbreakers. Just switch out one or two of the perpetually aggrieved photos and update the prompts that aren't landing`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...leonReviewerReviewBumble },
  reviewerProfile: { ...leonReviewerProfile },
  bioItems: { ...larryBio },
  mediaItems: [ ...larryMediaArray ],
}

export const leonProfileReviewTinder = {
  _id: 'leonProfileReviewTinderId',
  userId: 'larryUserId',
  userEmail: 'larry@email.com',
  datingProfileId: 'larryDatingProfileTinderId',
  reviewerProfileId: 'leonReviewerProfileId',
  reviewerEmail: 'leon@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: larryMediaArray[12]._id,
      mediaItemURL: larryMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[12].type,
      caption: larryMediaArray[12].captions[0],
      subcaption: larryMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[1]._id,
      mediaItemURL: larryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[1].type,
      caption: larryMediaArray[1].captions[0],
      subcaption: larryMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[8]._id,
      mediaItemURL: larryMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[8].type,
      caption: larryMediaArray[8].captions[0],
      subcaption: larryMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[20]._id,
      mediaItemURL: larryMediaArray[20].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[20].type,
      caption: larryMediaArray[20].captions[0],
      subcaption: larryMediaArray[20].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[10]._id,
      mediaItemURL: larryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[10].type,
      caption: larryMediaArray[10].captions[0],
      subcaption: larryMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[13]._id,
      mediaItemURL: larryMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[13].type,
      caption: larryMediaArray[13].captions[0],
      subcaption: larryMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow! What a romantic! I didn't know you had this in you Larry`,
      verdict: 'Very',
    },
    {
      feedback: `The jacket, the desk, and the relaxed leg are all good. I like the photo`,
      verdict: 'Yes',
    },
    {
      feedback: `Kind of funny, but this perpetually aggrieved look makes you seem a bit difficult`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Fun change of pace. Maybe explain it in the captions`,
      verdict: 'Yes',
    },
    {
      feedback: `Social proof, gotta have it`,
      verdict: 'Yes',
    },
    {
      feedback: `Three perpetually aggrieved expressions out of six photos might be a bit much. Like the setting though`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: larryBio._id,
    vitalInfo: { ...larryBio.vitalInfo },
    prompts: [
      { ...larryBio.prompts[0] },
      { ...larryBio.prompts[1] },
      { ...larryBio.prompts[2] }
    ],
    aboutMe: larryBio.aboutMe[0],
    hobbies: [larryBio.hobbies[0], larryBio.hobbies[1], larryBio.hobbies[2], larryBio.hobbies[3], larryBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Comedian barely explains it. You gotta mention that you created Seinfeld!`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: 'Yes, this is funny',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get the reference here`,
        verdict: 'No', 
      },
      {
        feedback: `I like this, it shows you as detail oriented`,
        verdict: 'Yes', 
      },
      {
        feedback: `Maybe a bit too intense, but it does allow you to tell your story about donating a kidney for your friend`,
        verdict: 'Somewhat', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Larry is well put together and has a good sense of humor but might be a bit difficult in a perpetually aggrieved sort of way`,
    good: `You seem funny and well put together with a lot of character`,
    notGood: `Some of the prompts don't land, you should flaunt Seinfeld, and you should switch out one or two of the perpetually aggrieved photos`,
    verdict: `Honestly it's a pretty good profile. No dealbreakers. Just switch out one or two of the perpetually aggrieved photos and update the prompts that aren't landing`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...leonReviewerReviewTinder },
  reviewerProfile: { ...leonReviewerProfile },
  bioItems: { ...larryBio },
  mediaItems: [ ...larryMediaArray ],
}